import getTextWidth from './get-text-width';

// Labeled drag trigger styles that needed for element width calculation
// are stored as custom CSS properties to get and share them easier
function getCssCustomPropValue(prop, targetDocument) {
  return getComputedStyle(targetDocument.documentElement).getPropertyValue(prop);
}

function getCssCustomPropNumericValue(prop, targetDocument) {
  return parseInt(getCssCustomPropValue(prop, targetDocument), 10);
}

function getLabelPaddingVariableNames(isDragTrigger, isLayerSelectShown) {
  let labelPaddingLeftVariableName = '--ws-trigger-label__padding-left';
  let labelPaddingRightVariableName = '--ws-trigger-label__padding-right';

  if (isLayerSelectShown && isDragTrigger) {
    labelPaddingLeftVariableName = '--ws-trigger-label-custom-with-drag-layer-select-padding-left';
    labelPaddingRightVariableName =
      '--ws-trigger-label-custom-with-drag-layer-select-padding-right';
  } else if (isLayerSelectShown) {
    labelPaddingLeftVariableName = '--ws-trigger-label-custom-with-layer-select-padding-left';
    labelPaddingRightVariableName = '--ws-trigger-label-custom-with-layer-select-padding-right';
  } else if (isDragTrigger) {
    labelPaddingLeftVariableName = '--ws-trigger-label-custom-padding-left';
    labelPaddingRightVariableName = '--ws-trigger-label-custom-padding-right';
  }

  return { labelPaddingLeftVariableName, labelPaddingRightVariableName };
}

function getLabelWidthParts(label, isDragTrigger = false, isLayerSelectShown = false) {
  const labelFontSize = getCssCustomPropValue('--ws-trigger-label__font-size', document);
  const labelFontFamily = getCssCustomPropValue('--ws-trigger-label__font-family', document);
  const labelTextWidthRaw = getTextWidth(label, `${labelFontSize} ${labelFontFamily}`, document);
  const labelMaxWidth = 140;
  const textEllipsisThreshold = 2; // Prevent text-overflow to be triggered too early
  const labelTextWidth =
    labelTextWidthRaw < labelMaxWidth
      ? labelTextWidthRaw + textEllipsisThreshold
      : labelMaxWidth + textEllipsisThreshold;

  const { labelPaddingLeftVariableName, labelPaddingRightVariableName } =
    getLabelPaddingVariableNames(isDragTrigger, isLayerSelectShown);

  const triggerInnerPadding = getCssCustomPropNumericValue('--ws-trigger__inner-padding', document);
  const labelPaddingLeft = getCssCustomPropNumericValue(labelPaddingLeftVariableName, document);
  const labelPaddingRight = getCssCustomPropNumericValue(labelPaddingRightVariableName, document);

  return {
    triggerInnerPadding,
    labelPaddingLeft,
    labelTextWidth,
    labelPaddingRight,
  };
}

function getLabelTriggerWidth(label, isDragTrigger = false, isLayerSelectShown = false) {
  const { triggerInnerPadding, labelPaddingLeft, labelTextWidth, labelPaddingRight } =
    getLabelWidthParts(label, isDragTrigger, isLayerSelectShown);

  return triggerInnerPadding * 2 + labelPaddingLeft + labelTextWidth + labelPaddingRight;
}

export { getLabelWidthParts };
export default getLabelTriggerWidth;
